import { AlgoliaSearchParams } from '../../../types/AlgoliaSearchParams';
import { CONTENT_INDEX_NAME } from '../indexNames';
import { PREEMPTIVE_FILTER_TEMPLATES } from '../preemption/templates';

export const USER_FILTERS = PREEMPTIVE_FILTER_TEMPLATES.user;
export const USER_CONFIGURE_OPTIONS: AlgoliaSearchParams = {
  index: CONTENT_INDEX_NAME,
  filters: USER_FILTERS,
};
